'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["open", "className", "pinToConstraint", "onRemove", "children", "storeHandlers", "EmojiPicker", "onInsertEmoji"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import withTinyMcePopoverLifecycle from '../hoc/withTinyMcePopoverLifecycle';
import EmojiPickerWrapper from 'ui-addon-emoji-picker/picker/EmojiPickerWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
class EmojiPickerPopover extends Component {
  constructor(...args) {
    super(...args);
    this.handleEmojiClick = emoji => {
      this.props.onInsertEmoji(emoji);
      this.popoverRef.focus();
    };
  }
  render() {
    const _this$props = this.props,
      {
        open,
        className,
        pinToConstraint,
        onRemove,
        children,
        storeHandlers,
        EmojiPicker
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const popoverProps = Object.assign({
      open,
      className,
      pinToConstraint,
      autoPlacement: true,
      animateOnToggle: false,
      arrowSize: 'none',
      placement: 'bottom right',
      closeOnOutsideClick: true,
      onOpenChange: onRemove
    }, rest);

    // TODO: Add onSelect prop, notFound custom emoji when emoji-mart bender-repackage is updated
    return /*#__PURE__*/_jsx(EmojiPickerWrapper, {
      ref: el => this.popoverRef = el,
      native: true,
      autoFocus: true,
      onClick: this.handleEmojiClick,
      popoverProps: popoverProps,
      useDefaultFilter: true,
      unicodeVersion: 8.0,
      storeHandlers: storeHandlers,
      PickerContent: EmojiPicker,
      children: children
    });
  }
}
EmojiPickerPopover.propTypes = {
  EmojiPicker: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onRemove: PropTypes.func.isRequired,
  onInsertEmoji: PropTypes.func.isRequired,
  storeHandlers: PropTypes.shape({
    init: PropTypes.func,
    getter: PropTypes.func,
    setter: PropTypes.func
  }),
  children: PropTypes.object,
  className: PropTypes.string,
  pinToConstraint: PropTypes.array
};
export default withTinyMcePopoverLifecycle(EmojiPickerPopover);